import * as React from 'react';
import calculateColumnIndexFromPoint from '../../store/calculation/calculateColumnIndexFromPoint';
import CalendarSurfaceStore from '../../store/schema/CalendarSurfaceStore';
import { addDays } from 'owa-datetime';
import { CalendarSurfaceTransformProps } from '../../interfaces/CalendarSurfaceTransformProps';
import { SurfaceEventHandlers } from '../../interfaces/SurfaceEventHandlers';

/**
 * Helper function to wrap all day well with behavior
 * @param {CalendarSurfaceStore} surfaceStore - the surface store
 * @param {JSX.Element} content - column content
 */

/**
 * AllDayWellBehavior Properties
 * config - the calendar day config
 * store- the calendar surface store
 */
export interface AllDayWellBehaviorProps {
    config: CalendarSurfaceTransformProps;
    store: CalendarSurfaceStore;
    calendarFolderId?: string;
}

/**
 * All day well behavior - injects click and right click handlers
 * Invokes consumer provided callback on click event
 */
export default class AllDayWellBehavior extends React.Component<AllDayWellBehaviorProps, any> {
    render() {
        return null;
    }

    /**
     * List of event handlers this behavior attaches to target
     */
    handlers(): SurfaceEventHandlers {
        return {
            onContextMenu: this.onContextMenu,
            onClick: this.onClick,
            onDoubleClick: this.onDoubleClick,
        };
    }

    private onContextMenu = (ev: React.MouseEvent<HTMLDivElement>) => {
        let { onSurfaceRightClick } = this.props.config;
        ev.persist();
        if (onSurfaceRightClick) {
            let dateRange = this.pointToDate(ev, this.props.store.userOptions.isRTL);
            onSurfaceRightClick(dateRange.start, dateRange.end, true, ev.nativeEvent);
        }
        ev.stopPropagation();
        ev.preventDefault();
    };

    private onDoubleClick = (evt: React.MouseEvent<HTMLElement>) => {
        let { onSurfaceDoubleClick } = this.props.config;
        if (onSurfaceDoubleClick) {
            let dateRange = this.pointToDate(evt, this.props.store.userOptions.isRTL);
            onSurfaceDoubleClick(
                dateRange.start,
                dateRange.end,
                true,
                false /* No click and drag scenario */,
                this.props.calendarFolderId
            );
        }
    };

    private onClick = (evt: React.MouseEvent<HTMLElement>) => {
        let { onSurfaceClick } = this.props.config;
        if (onSurfaceClick) {
            let dateRange = this.pointToDate(evt, this.props.store.userOptions.isRTL);
            onSurfaceClick(
                dateRange.start,
                dateRange.end,
                true,
                false /* No click and drag scenario */,
                this.props.calendarFolderId
            );
        }
    };

    private pointToDate = (evt: React.MouseEvent<HTMLElement>, isRTL: boolean) => {
        let boundingRect = evt.currentTarget.getBoundingClientRect();
        let colIndex = calculateColumnIndexFromPoint(
            evt.pageX,
            boundingRect,
            this.props.config.columnProvider,
            isRTL
        );

        let startDate = this.props.config.columnProvider.getColumnDate(colIndex);
        let endDate = addDays(startDate, 1);
        return {
            start: startDate,
            end: endDate,
        };
    };
}
